import { createSlice } from "@reduxjs/toolkit";

import {
  getServiceThunk,
  createServiceThunk,
  updateServiceThunk,
  deleteServiceThunk,
} from "state/action/service";

// Initial state
const initialState = {
  // Get Service inisial state
  getService: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Service inisial state
  createService: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Service inisial state
  updateService: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Service inisial state
  deleteService: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },

  createServiceInputBody: {
    code: "",
    service_name: "",
    division: "",
    description: "",
    user_group: [],
  },

  createUserGroup: {
    division: "",
    department: "",
    users: [],
  },
  selectedService: {
    division: "",
    department: "",
    users: [],
  },
  // Service object value
  service_object_value: "",
};

export const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    setServiceField: (state, action) => {
      const { field, value } = action.payload;
      state.createServiceInputBody[field] = value;
    },
    // User Group Actions
    addUserGroup: (state) => {
      state.createServiceInputBody.user_group.push({
        division: "",
        department: "",
        users: [],
      });
    },
    removeUserGroup: (state, action) => {
      state.createServiceInputBody.user_group.splice(action.payload, 1);
    },
    updateUserGroup: (state, action) => {
      const { index, field, value } = action.payload;
      state.createServiceInputBody.user_group[index][field] = value;
    },
    resetServiceForm: (state) => {
      state.createServiceInputBody = initialState.createServiceInputBody;
    },
    setUserGroupField: (state, action) => {
      const { field, value } = action.payload;
      state.createUserGroup[field] = value;
    },
    // Khusus untuk array users (jika menggunakan multiselect)
    setUsersList: (state, action) => {
      state.createUserGroup.users = action.payload;
    },
    resetUserGroupForm: (state) => {
      state.createUserGroup = initialState.createUserGroup;
    },
    setGetServiceObjectValue: (state, action) => {
      return {
        ...state,
        service_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetServiceObjectValue: (state, _) => {
      return {
        ...state,
        service_object_value: "",
      };
    },
    setCreateServiceInputBody: (state, action) => {
      return {
        ...state,
        createServiceInputBody: action.payload,
      };
    },
    setSelectedService: (state, action) => {
      return {
        ...state,
        selectedService: action.payload,
      };
    },
    setClearCreateServiceInputBody: (state, _) => {
      return {
        ...state,
        createServiceInputBody: {
          code: "",
          service_name: "",
          division: "",
          description: "",
        },
      };
    },
    setClearCreateService: (state, _) => {
      return {
        ...state,
        createService: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearGetService: (state, _) => {
      return {
        ...state,
        getService: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateService: (state, _) => {
      return {
        ...state,
        updateService: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteService: (state, _) => {
      return {
        ...state,
        deleteService: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllServiceState: (state, _) => {
      return {
        ...state,
        // Get Service inisial state
        getService: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Service inisial state
        createService: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Service inisial state
        updateService: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Service inisial state
        deleteService: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Service object value
        Service_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Service reducer
      .addCase(getServiceThunk.pending, (state, _) => {
        return {
          ...state,
          getService: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getServiceThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getService: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getServiceThunk.rejected, (state, action) => {
        return {
          ...state,
          getService: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Service reducer
      .addCase(createServiceThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createServiceThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createServiceThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Service reducer
      .addCase(updateServiceThunk.pending, (state, _) => {
        return {
          ...state,
          updateService: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateServiceThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateService: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateServiceThunk.rejected, (state, action) => {
        return {
          ...state,
          updateService: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Delete Service reducer
      .addCase(deleteServiceThunk.pending, (state, _) => {
        return {
          ...state,
          deleteService: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(deleteServiceThunk.fulfilled, (state, action) => {
        return {
          ...state,
          deleteService: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(deleteServiceThunk.rejected, (state, action) => {
        return {
          ...state,
          deleteService: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const serviceAction = {
  ...serviceSlice.actions,
  getServiceThunk,
  createServiceThunk,
  updateServiceThunk,
  deleteServiceThunk,
};

export function selectServiceObjectValue(state) {
  return state?.service?.service_object_value;
}

export function selectService(state) {
  return state?.service;
}

export default serviceSlice.reducer;
